import { render, staticRenderFns } from "./resi-agen-print.vue?vue&type=template&id=453be59b&scoped=true"
import script from "./resi-agen-print.vue?vue&type=script&lang=js"
export * from "./resi-agen-print.vue?vue&type=script&lang=js"
import style0 from "./resi-agen-print.vue?vue&type=style&index=0&id=453be59b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453be59b",
  null
  
)

export default component.exports